module.exports = __webpack_public_path__ + "img/19.5141312c.jpg";